import { object, number } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { NUMBER_TYPE_TEXT, REQUIRED_TEXT } = getValidationTexts();
    return object().shape({
        wind_speed: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .nullable(),
        snow_load: number()
            .typeError(NUMBER_TYPE_TEXT)
            .required(REQUIRED_TEXT)
            .nullable(),
    });
};
